import React, { ReactElement } from 'react';
import 'assets/scss/main-container.scss';

type containerProps = {
	children: ReactElement;
	isResponse?: boolean;
};

export const MainContainer = ({ children, isResponse }: containerProps) => {
	return (
		<div className={`main-container ${isResponse ? 'background-response' : ''}`}>{children}</div>
	);
};
